import { render, staticRenderFns } from "./ForgotPasswordModal.vue?vue&type=template&id=554d046c&scoped=true&"
import script from "./ForgotPasswordModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ForgotPasswordModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ForgotPasswordModal.vue?vue&type=style&index=0&id=554d046c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d046c",
  null
  
)

export default component.exports